import { reactive } from 'vue'

export function useManageInventoryDialog () {
  const state = reactive({
    config: null,
    isOpen: false
  })

  const open = (config) => {
    state.config = config
    state.isOpen = true
  }

  const close = () => {
    state.config = null
    state.isOpen = false
  }

  const setValidationErrors = (value) => {
    state.validationErrors = value
  }

  return {
    state,
    open,
    close,
    setValidationErrors
  }
}
